export const TOOLTIP_POSITION_TOP = 'top'
export const TOOLTIP_POSITION_RIGHT = 'right'
export const TOOLTIP_POSITION_LEFT = 'left'
export const TOOLTIP_POSITION_BOTTOM = 'bottom'

export const TOOLTIP_POSITIONS = [
  TOOLTIP_POSITION_TOP,
  TOOLTIP_POSITION_BOTTOM,
  TOOLTIP_POSITION_LEFT,
  TOOLTIP_POSITION_RIGHT
]

export type TooltipPositionTypes = typeof TOOLTIP_POSITIONS[number]
